import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Moment from 'moment'
import SkeletonTable from '../../../common/skeleton-table'
import Y from '../../../y18n'
import Styles from '../../../common/styles'

class EventHistory extends Component {
  state = {
    sort: { orderBy: 'timestamp', direction: 'desc' },
    page: 0,
    rowsPerPage: 10
  }

  handleSortChange = name => event => {
    var direction = this.state.sort.direction === 'asc' ? 'desc' : 'asc'
    this.setState({ sort: { orderBy: name, direction: direction } })
  }

  render () {
    const { subscription, statusLoading, classes } = this.props
    return (
      <div style={{ marginTop: '40px' }}>
        <div className={classes.textRow}>
          <Typography variant='title'>
            {Y`Event history`}
          </Typography>
          <Typography variant='body2'>
            {Y`This table displays a log of events for this subscription`}
          </Typography>
        </div>
        <Paper className={classes.spacer}>
          <div className={classes.tableWrapper}>
            <Table className={'striped'}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <TableSortLabel
                      active={this.state.sort.orderBy === 'timestamp'}
                      direction={this.state.sort.direction}
                      onClick={this.handleSortChange('timestamp')}
                    >
                      {Y`Timestamp`}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={this.state.sort.orderBy === 'change'}
                      direction={this.state.sort.direction}
                      onClick={this.handleSortChange('change')}
                    >
                      {Y`Change`}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={this.state.sort.orderBy === 'user'}
                      direction={this.state.sort.direction}
                      onClick={this.handleSortChange('user')}
                    >
                      {Y`User`}
                    </TableSortLabel>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {subscription.loading || statusLoading || !subscription.detailedSubscription
                  ? <SkeletonTable rows={10} cols={3} />
                  : this.state.sort.direction === 'desc'
                      ? subscription.detailedSubscription.events
                          .sort((a, b) => (b[this.state.sort.orderBy] <= a[this.state.sort.orderBy] ? -1 : 1))
                          .slice(
                            this.state.page * this.state.rowsPerPage,
                            this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
                          )
                          .map(event => this.renderEvent(event))
                      : subscription.detailedSubscription.events
                          .sort((a, b) => (a[this.state.sort.orderBy] <= b[this.state.sort.orderBy] ? -1 : 1))
                          .slice(
                            this.state.page * this.state.rowsPerPage,
                            this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
                          )
                          .map(event => this.renderEvent(event))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    count={subscription.detailedSubscription ? subscription.detailedSubscription.events.length : 0}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </div>
        </Paper>
      </div>
    )
  }

  renderEvent (event) {
    return (
      <TableRow key={event.timestamp}>
        <TableCell>{Moment.utc(event.timestamp).local().format('YYYY-MM-DD HH:mm:ss')}</TableCell>
        <TableCell><div dangerouslySetInnerHTML={{ __html: event.change }} /></TableCell>
        <TableCell>{event.user}</TableCell>
      </TableRow>
    )
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page })
  }

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value })
  }
}

export default withStyles(Styles)(EventHistory)



// WEBPACK FOOTER //
// ./src/pages/subscription-details/components/event-history.js